import Vue from 'vue';
import Highcharts from 'highcharts-vue';

Vue.use(Highcharts);

export default {
    
}